<div class="general-info flex space-x-3.5">
  <div class="general-info-container container-background rounded-lg grow item w-full h-full overflow-y-auto relative">
    <!-- General Info -->
    <div class="header rounded-lg flex items-center sticky top-0 asset-details p-4 z-50">
      <div class="title text-xl">
        <div *ngIf="brandingKey !== CustomClients.Vorwerk" i18n>General Info</div>
      </div>

      @if (screenSizeDetectorService.isLargeScreen) {
        <div class="actions text-right">
          <div class="actions-wrapper flex justify-end">
            <button *ngIf="isOwner && (AnyAsset | can: 'collection.create')" mat-icon-button class="cursor-pointer" i18n-matTooltip matTooltip="Edit collection" (click)="editInformation()">
              <mat-icon class="material-icons-outlined">edit</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
    <div class="details pt-1 px-4">
      <div class="detail-header">
        <div class="detail-info pb-1">
          <div class="detail-wrapper pb-5 mt-2 items-start">
            <span class="field-label font-bold" i18n>Name</span>
            <div class="inline-block break-words">
              <span>{{ collectionInfo && collectionInfo.name }}</span>
            </div>
          </div>
          <div
            class="detail-wrapper pb-5 mt-2 items-start"
            *ngIf="collectionInfo?.published?.length && [CustomClients.Vorwerk, CustomClients.Standard, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge].includes(brandingKey)"
          >
            <div class="field-label" i18n>Specification for publishing</div>
            <div class="inline-block break-words">
              <table class="publishing-details-table">
                <thead>
                  <tr>
                    <th class="w-40">
                      @if (brandingKey === CustomClients.Vorwerk) {
                        <ng-container i18n>Domain</ng-container>
                      } @else {
                        <ng-container i18n>Agency</ng-container>
                      }
                    </th>
                    <th colspan="2">
                      <span class="client-wrapper">
                        <span class="client-name">
                          @if (brandingKey === CustomClients.Vorwerk) {
                            <ng-container i18n>Location</ng-container>
                          } @else {
                            <ng-container i18n>Client</ng-container>
                          }
                        </span>
                        <span class="brands-wrapper" i18n>Brand</span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let agency of collectionInfo?.published">
                    <td class="agency-wrapper">
                      <span>{{ agency.name }}</span>
                    </td>
                    <td colspan="2">
                      <span class="client-wrapper" *ngFor="let client of agency.clients">
                        <span class="client-name">{{ client.name }}</span>
                        <span class="brands-wrapper" *ngIf="client.brands">
                          <span *ngFor="let brand of client.brands; let i = index"> {{ brand.name }}<span *ngIf="i < client.brands.length - 1">,</span></span>
                        </span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="detail-wrapper py-1 flex items-start">
            <span class="field-label" i18n>Description</span>
            <div class="inline-block break-words">
              <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]">
                <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="collectionInfo && collectionInfo.description"></div>
              </div>
            </div>
          </div>
          <div class="detail-wrapper py-5 flex items-start">
            <span class="mb-1 field-label" i18n>Tags</span>
            <div class="inline-block break-words">
              <span>
                <sp-chips-listbox-option [dataSource]="collectionForm.controls['keywords'].value" [chipViewMode]="'view'" class="view-mode"></sp-chips-listbox-option>
              </span>
            </div>
          </div>
          <div class="detail-wrapper py-5 flex items-start">
            <span class="field-label" i18n>Cover</span>
            <div class="detail-collection-cover break-words flex items-center">
              <img class="rounded-xl w-[25%] h-auto" *ngIf="selectedCovered && selectedCovered.imageUrl" [src]="selectedCovered.imageUrl | imageLoading | async" [alt]="selectedCovered.name" />
              <span class="ml-5">{{ selectedCovered?.name }}</span>
              <span *ngIf="!selectedCovered?.imageUrl" i18n>Cover not selected</span>
            </div>
          </div>
          <div class="detail-wrapper py-5 flex items-start">
            <span class="mb-1 field-label" i18n>Owners</span>
            <div class="detail-owner-container break-words flex items-center mb-2">
              <div class="detail-owner-wrapper" *ngFor="let user of collectionOwners">
                <sp-avatar [user]="user" [size]="30" [fontSize]="12" [showToolTip]="false"> </sp-avatar>
                <span class="detail-owner ml-5">{{ valueListsService.lookupUserName(user) | async }} <span *ngIf="user === collectionCreatedBy" class="!font-medium" i18n>(Created by)</span></span>
              </div>
              <div class="detail-owner-wrapper">
                <sp-avatar [user]="collectionCreatedBy" [size]="30" [fontSize]="12" [showToolTip]="false"> </sp-avatar>
                <span class="detail-owner ml-5">{{ valueListsService.lookupUserName(collectionCreatedBy) | async }} <span class="!font-medium" i18n>(Created by)</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
